import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React, {forwardRef} from 'react';

export const CheckoutLoadingSpinner = forwardRef<
  HTMLDivElement,
  {className?: string}
>(function CheckoutLoadingSpinner({className}, ref) {
  return <LoadingPageSpinner ref={ref} className={className} />;
});
